var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUndergroundActivity = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 37 37",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.734 26.355 29.338 16.13a3.72 3.72 0 0 0-2.5-1.906 11 11 0 0 0-.16-.846q.015-.099.01-.203c0-.029-.011-.328-.096-.785-.15-.976-.5-2.813-1.24-4.669-1.884-4.73-4.734-5.754-6.811-5.77h-.01a6.04 6.04 0 0 0-3.478 1.118c-1.209.848-2.392 2.287-3.334 4.652-.74 1.856-1.09 3.693-1.24 4.67a5.4 5.4 0 0 0-.097.784q-.003.105.01.203a11 11 0 0 0-.159.846 3.72 3.72 0 0 0-2.5 1.906L2.337 26.355a2.78 2.78 0 0 0 .08 2.756 2.78 2.78 0 0 0 2.4 1.356h3.521l-.59-8.51a2.837 2.837 0 0 1 .752-2.124 2.84 2.84 0 0 1 2.068-.898h5.064c-1.737-.672-2.543-1.828-2.911-2.29-.47-.591-.532-1.442-.208-2.844.327-1.41.62-2.369.873-3.018l.056-.082v1.246a5.157 5.157 0 0 0 5.088 5.15h.01a5.14 5.14 0 0 0 3.6-1.53 5.13 5.13 0 0 0 1.489-3.62v-1.246q.03.041.056.082c.252.65.546 1.607.873 3.018.324 1.402.262 2.253-.208 2.844-.368.462-1.174 1.618-2.911 2.29h5.064c.781 0 1.535.328 2.067.899a2.84 2.84 0 0 1 .753 2.124l-.59 8.509h3.52c.993 0 1.89-.508 2.401-1.356.513-.85.542-1.88.08-2.756"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.503 21.095H10.568a.668.668 0 0 0-.666.714l.607 8.73c.024.348.316.62.665.62h14.723c.35 0 .64-.272.665-.62l.607-8.73a.67.67 0 0 0-.666-.714"
  })));
};
export default SvgUndergroundActivity;